import { Table } from "antd";
import { Dashboard, Employees } from "../../utils/constant";
import CustomPopup from "../../components/CustomPopup/CustomPopup";
import "./dashboard.css";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import CustomSelect from "../../components/common/Select/Select";
import SearchBar from "../../components/common/SearchBar/SearchBar";
import greenBar from "../../assets/images/green_bar.png";
import orangeBar from "../../assets/images/orange_bar.png";
import blueBar from "../../assets/images/blue_bar.png";
import PatientImg from "../../assets/images/patient.png";
import { Col, Container, Row } from "react-bootstrap";

import {
  Area,
  Bar,
  BarChart,
  CartesianGrid,
  Customized,
  Legend,
  Line,
  LineChart,
  RadialBar,
  RadialBarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { api } from "../../api/api";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";

const DashboardHome = () => {
  const [dashboardData, setDashboardData] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { currUserData } = useAuthContext();
  const [show, setShow] = useState(false);
  const [value, onChange] = useState(new Date());
  const dataSource = Dashboard?.datasource;
  const columns = Dashboard?.column;
  // const rowSelection = {
  //   onlick: (selectedRowKeys, selectedRows) => {
  //     console.log(
  //       `selectedRowKeys: ${selectedRowKeys}`,
  //       "selectedRows: ",
  //       selectedRows
  //     );
  //   },
  // };

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleRegistration = async (data) => {
    console.log(data, "form");
  };

  const registerOptions = {
    firstname: "please",
  };

  const data = [
    { day: "Mon", value: 40 },
    { day: "Tue", value: 60 },
    { day: "Wed", value: 50 },
    { day: "Thu", value: 70 },
    { day: "Fri", value: 60 },
    { day: "Sat", value: 80 },
    { day: "Sun", value: 100 },
  ];

  const monthly = [
    { value: 50 }, // 75% progress (orange color)
  ];
  const tileClassName = ({ date, view }) => {
    if (view === "month") {
      const formattedDate = date.getDate();
      if (formattedDate === 13) return "highlight-purple";
      if (formattedDate === 22) return "highlight-green";
      if (formattedDate === 25) return "highlight-red";
      if (formattedDate === 27) return "highlight-yellow";
    }
    return "";
  };

  const getDashboardData = async (term = "") => {
    setIsLoading(true);
    let res = await api(
      `api/v1/dashboard/stats`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res res");
      setDashboardData(res?.data);

      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  // 📦 Function to convert API data to chart format
  const formatLabel = (year, month) =>
    new Date(year, month - 1).toLocaleString("default", {
      month: "short",
      year: "numeric",
    });

  // 🧠 Smart data generator
  const getSmartActivityData = (apiData) => {
    if (!apiData || apiData.length === 0) return [];
    console.log(apiData, "1");

    if (apiData.length === 1) {
      // Only one point from API — pad with 2 months before and after
      const single = apiData[0];
      const baseDate = new Date(single.year, single.month - 1);
      console.log(single, "2");

      const result = [];
      for (let i = -2; i <= 2; i++) {
        const date = new Date(baseDate.getFullYear(), baseDate.getMonth() + i);
        const label = formatLabel(date.getFullYear(), date.getMonth() + 1);
        const isRealData =
          date.getMonth() + 1 === single.month &&
          date.getFullYear() === single.year;

        result.push({
          name: label,
          revenue: isRealData ? single.revenue : 0,
        });
      }

      console.log(result, "3");

      return result;
    } else {
      // Multiple points — just map them
      return apiData.map((item) => ({
        name: formatLabel(item.year, item.month),
        revenue: item.revenue,
      }));
    }
  };

  const activity = getSmartActivityData(dashboardData?.monthlyRevenue);

  return (
    <>
      <div className="appointment_list p-40">
        <Row>
          <Col md="12">
            <div className="dashboard_card">
              <Row className="">
                <Col md="4">
                  <div className="card_inner">
                    <img src={orangeBar} alt="" />

                    <ul>
                      <li>
                        <div className="icon">
                          <i class="fas fa-user-friends"></i>
                        </div>
                        <h4>
                          <p>Total Students</p>
                          {dashboardData?.totalStudents}
                        </h4>
                      </li>
                      {/* <li>
                        <span>
                          <i className="fas fa-sort-up me-2"></i> +1.02%
                        </span>
                      </li> */}
                    </ul>
                  </div>
                </Col>
                <Col md="4">
                  <div className="card_inner green">
                    <img src={greenBar} alt="" />

                    <ul>
                      <li>
                        <div className="icon">
                          <i class="fas fa-eye"></i>
                        </div>
                        <h4>
                          <p>Premium Students</p>
                          {dashboardData?.premiumStudents}
                        </h4>
                      </li>
                      {/* <li>
                        <span>
                          <i className="fas fa-sort-up me-2"></i> +1.02%
                        </span>
                      </li> */}
                    </ul>
                  </div>
                </Col>
                <Col md="4">
                  <div className="card_inner blue">
                    <img src={blueBar} alt="" />

                    <ul>
                      <li>
                        <div className="icon">
                          <i class="fas fa-rupee-sign"></i>
                        </div>
                        <h4>
                          <p>Total Revenue</p>
                          {dashboardData?.totalRevenue}
                        </h4>
                      </li>
                      {/* <li>
                        <span>
                          <i className="fas fa-sort-up me-2"></i> +1.02%
                        </span>
                      </li> */}
                    </ul>
                  </div>
                </Col>

                <Col md="12">
                  <div className="activity_chart card_inner">
                    <h2>Monthly Revenue</h2>
                    <ResponsiveContainer width="100%" height={300}>
                      <LineChart
                        data={activity}
                        margin={{
                          top: 20,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis
                          dataKey="name"
                          tick={{
                            fontSize: 14,
                            fill: "#AEAEAE",
                            fontWeight: "400",
                          }}
                        />
                        <YAxis
                          ticks={[1, 5, 10, 15, 20]}
                          axisLine={false}
                          tick={{
                            fontSize: 14,
                            fill: "#AEAEAE",
                            fontWeight: "400",
                          }}
                        />
                        <Tooltip
                          contentStyle={{
                            // backgroundColor: "#2c3e50", // Dark background color
                            borderRadius: "8px", // Rounded corners
                            padding: "10px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                            width: "120px", // ✅ Fixed width
                            whiteSpace: "nowrap", // ✅ Prevent line breaks
                            overflow: "hidden", // ✅ Hide overflow
                            textOverflow: "ellipsis",
                          }}
                          labelStyle={{
                            color: "#AEAEAE", // White color for the label (X-axis label)
                            fontWeight: "400",
                            fontSize: "14px",
                          }}
                          formatter={(value) => [`₹${value}`, "Revenue"]}
                        />
                        <Area
                          type="monotone"
                          dataKey="revenue"
                          stroke="none"
                          fill="#8884d8" // Background fill color beneath the line
                          fillOpacity={0.3} // Adjust transparency if needed
                        />
                        <Line
                          type="monotone"
                          dataKey="revenue"
                          stroke="#FF7D38"
                          strokeWidth={4}
                          // fill="#8884d8"
                          // fillOpacity={0.2}
                        />
                        <Bar dataKey="revenue" fill="#8884d8" barSize={20} />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </Col>
                <Col md="12">
                  <div className="activity_chart card_inner">
                    <h2>Best Selling Courses</h2>
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart
                        data={dashboardData?.bestSellingCourses}
                        margin={{ top: 20, right: 30, left: 20, bottom: 40 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis
                          dataKey="title"
                          angle={-30}
                          textAnchor="end"
                          tick={{
                            fontSize: 14,
                            fill: "#AEAEAE",
                            fontWeight: "400",
                          }}
                        />
                        <YAxis
                          tick={{
                            fontSize: 14,
                            fill: "#AEAEAE",
                            fontWeight: "400",
                          }}
                          // label={{
                          //   value: "Enrolled Students",
                          //   angle: -90,
                          //   position: "insideLeft",
                          //   fill: "#AEAEAE",
                          // }}
                        />
                        <Tooltip
                          contentStyle={{
                            width: "160px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            borderRadius: "8px",
                            padding: "10px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                          }}
                          formatter={(value, name) =>
                            name === "enrolledStudents"
                              ? [`👨‍🎓 ${value}`, "Students"]
                              : [`$${value}`, "Price"]
                          }
                        />
                        <Bar
                          dataKey="enrolledStudents"
                          fill="#FF7D38"
                          barSize={30}
                          activeBar={{ fill: "#FF4500", radius: [6, 6, 0, 0] }}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          {/* <Col md="4">
            <div className=" dashboard_right ">
              <div className="profile">
                <div className="more text-end">
                  <More />
                </div>
                <div className="profile_content">
                  <div className="profile_img">
                    <img src={profile} alt="" />
                  </div>
                  <h2>Dianne Russell</h2>
                  <div className="rating">
                    <span>
                      {" "}
                      <Star /> 4.8
                    </span>
                    <span>
                      {" "}
                      <User /> 12.8K follower
                    </span>
                  </div>
                  <ul>
                    <li>
                      <p>Courses</p>
                      <span>120</span>
                    </li>
                    <li>
                      <p>Archievement</p>
                      <span>120</span>
                    </li>
                    <li>
                      <p>Certificates</p>
                      <span>120</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="calendar">
                <Calendar
                  onChange={onChange}
                  value={value}
                  tileClassName={tileClassName}
                />
              </div>
              <div className="upcoming_class">
                <div className="more d-flex justify-content-between align-items-center">
                  <p className="heading">Upcoming Class</p>
                  <More />
                </div>
                <div className="upcoming_name">
                  <div className="upcoming_name_inner">
                    <div className="icon me-2">
                      <Card1 />
                    </div>
                    <div>
                      <h4>Graphic Design</h4>
                      <p>8:00 AM to 9:30 AM</p>
                    </div>
                  </div>
                  <Arrow />
                </div>
                <div className="upcoming_name">
                  <div className="upcoming_name_inner">
                    <div className="icon me-2">
                      <Card1 />
                    </div>
                    <div>
                      <h4>Graphic Design</h4>
                      <p>8:00 AM to 9:30 AM</p>
                    </div>
                  </div>
                  <Arrow />
                </div>
                <div className="upcoming_name">
                  <div className="upcoming_name_inner">
                    <div className="icon me-2">
                      <Card1 />
                    </div>
                    <div>
                      <h4>Graphic Design</h4>
                      <p>8:00 AM to 9:30 AM</p>
                    </div>
                  </div>
                  <Arrow />
                </div>
                <div className="upcoming_name">
                  <div className="upcoming_name_inner">
                    <div className="icon me-2">
                      <Card1 />
                    </div>
                    <div>
                      <h4>Graphic Design</h4>
                      <p>8:00 AM to 9:30 AM</p>
                    </div>
                  </div>
                  <Arrow />
                </div>
              </div>
            </div>
          </Col> */}
        </Row>
      </div>
    </>
  );
};

export default DashboardHome;
